<template>
  <v-app app>
    <app-toolbar :rdrawer.sync="rdrawer" :ldrawer.sync="ldrawer" />
    <r-sidebar :appDrawer.sync="rdrawer" />
    <l-sidebar :appDrawer.sync="ldrawer" />
    <v-content>
      <v-slide-x-transition mode="out-in">
        <router-view />
      </v-slide-x-transition>
    </v-content>
    <v-snackbar
      right
      bottom
      class="mt-2"
      :timeout="6000"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      <span>{{ snackbar.text }}</span>
      <v-btn icon class="pl-0" @click="closeSnackbar" flat>
        <v-icon class="grey--text text--darken-3">cancel</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import LSidebar from "@/components/LSidebar";
import RSidebar from "@/components/RSidebar";
import appToolbar from "@/components/appToolbar";

export default {
  components: { appToolbar, LSidebar, RSidebar },
  data: () => ({
    rdrawer: true,
    ldrawer: false
  }),

  computed: {
    ...mapGetters({ snackbar: "globalSnackbar" })
  },

  methods: {
    closeSnackbar() {
      this.$store.commit("showSnackbar", {
        stateType: "",
        show: false,
        text: ""
      });
    }
  }
};
</script>
